import { ArrowRight, Clock, Shield, Award, Package } from "lucide-react";

export default function HeroSection({ companyInfo }) {
  const stats = companyInfo?.stats || {
    years: "25+",
    clients: "50+",
    products_delivered: "20,000+",
    cities: "10+",
  };

  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="py-20 md:py-32 px-6 md:px-12 max-w-7xl mx-auto"
    >
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12 items-center">
        {/* Content */}
        <div className="md:col-span-6 space-y-8">
          <div className="inline-flex items-center gap-2 bg-[#A7332B]/10 px-4 py-2 rounded-full">
            <Clock size={14} className="text-[#A7332B]" />
            <span
              data-testid="hero-years-badge"
              className="text-sm uppercase tracking-[0.2em] font-bold text-[#A7332B]"
            >
              25+ Years of Excellence
            </span>
          </div>

          <h1
            data-testid="hero-heading"
            className="font-heading text-5xl md:text-6xl font-black tracking-tighter text-[#040404] leading-[1.1]"
          >
            Engineered in
            <br />
            <span className="text-[#A7332B]">Stainless Steel</span>
            <br />
            Built for Extreme
            <br />
            <span className="text-[#A7332B]">Performance</span>
          </h1>

          <p
            data-testid="hero-description"
            className="text-base md:text-lg font-medium text-[#585857] leading-relaxed max-w-md"
          >
            India's trusted manufacturer of stainless steel yarn conditioning
            trolleys, ultra high molecular stainless steel castor wheels and stainless steel lycra bobbin trolleys. Engineering
            excellence since 1998.
          </p>

          <div className="flex flex-wrap gap-4">
            <a
              href="#products"
              data-testid="hero-cta-products"
              className="inline-flex items-center gap-2 bg-[#A7332B] text-[#EDE9E1] px-8 py-4 rounded-md font-bold tracking-wide hover:bg-[#040404] transition-colors"
            >
              View Products
              <ArrowRight size={16} />
            </a>
            <a
              href="#contact"
              data-testid="hero-cta-contact"
              className="inline-flex items-center gap-2 bg-transparent border-2 border-[#040404] text-[#040404] px-8 py-4 rounded-md font-bold hover:bg-[#040404] hover:text-[#EDE9E1] transition-colors"
            >
              Get in Touch
            </a>
          </div>
        </div>

        {/* Hero Image */}
        <div className="md:col-span-6 relative">
          <div className="relative w-full overflow-hidden rounded-xl border border-[#BEBEBD]/50 bg-[#EDE9E1]">
            <img
              src="/images/Trolley_7.jpeg"
              alt="Divya Enterprises - Industrial Manufacturing Excellence"
              data-testid="hero-image"
              className="w-full h-auto block"
              loading="eager"
            />
          </div>
        </div>
      </div>

      {/* Trust indicators with stats */}
      <div className="mt-16 md:mt-24 grid grid-cols-1 md:grid-cols-4 gap-8">
        {[
          { icon: Clock, title: stats.years, desc: "Years of Excellence" },
          { icon: Shield, title: stats.clients, desc: "Companies Served" },
          { icon: Package, title: stats.products_delivered, desc: "Products Delivered" },
          { icon: Award, title: stats.cities, desc: "Cities Covered" },
        ].map((item) => (
          <div key={item.desc} className="flex gap-4 items-start">
            <div className="flex-shrink-0 w-12 h-12 bg-[#A7332B]/10 rounded-lg flex items-center justify-center">
              <item.icon size={20} className="text-[#A7332B]" />
            </div>
            <div>
              <h3 className="font-heading font-black text-2xl text-[#040404]">
                {item.title}
              </h3>
              <p className="text-sm text-[#585857] mt-1">{item.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
